var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
export var ResizeType;
(function (ResizeType) {
    ResizeType["Horizontal"] = "horizontal";
    ResizeType["Vertical"] = "vertical";
})(ResizeType || (ResizeType = {}));
let QboResize = class QboResize extends LitElement {
    constructor() {
        super(...arguments);
        this.isResizing = false;
        this.type = ResizeType.Horizontal;
        this.startX = 0;
        this.startY = 0;
        this.startWidth = 0;
        this.startHeight = 0;
        this.previous = null;
        this.next = null;
    }
    static { this.styles = css `
  `; }
    xcreateRenderRoot() {
        return this;
    }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add(this.type === ResizeType.Horizontal ? 'horizontal' : 'vertical');
        this.previous = this.previousElementSibling;
        this.next = this.nextElementSibling;
        this.addEventListener('mousedown', this.onMouseDown);
        this.addEventListener('dblclick', this.clear);
        document.addEventListener('qbo-reset', this.clear.bind(this));
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('mousedown', this.onMouseDown);
        this.removeEventListener('dblclick', this.clear);
        document.removeEventListener('qbo-reset', this.clear.bind(this));
    }
    clear() {
        this.next?.classList.toggle('qbo-resize', false);
        this.previous.style.removeProperty('height');
        this.previous.style.removeProperty('width');
        this.next.style.removeProperty('height');
        this.next.style.removeProperty('width');
    }
    onMouseDown(event) {
        event.preventDefault();
        this.isResizing = true;
        this.startX = event.clientX;
        this.startY = event.clientY;
        //this.startWidth = this.leftElement?.offsetWidth || this.topElement?.offsetWidth || 0;
        //this.startHeight = this.topElement?.offsetHeight || this.leftElement?.offsetHeight || 0;
        this.startWidth = this.previous?.offsetWidth || 0;
        this.startHeight = this.previous?.offsetHeight || 0;
        const onMouseMove = (event) => {
            if (this.isResizing) {
                const deltaX = event.clientX - this.startX;
                const deltaY = event.clientY - this.startY;
                const newWidth = Math.max(this.startWidth + deltaX, 50);
                const newHeight = Math.max(this.startHeight + deltaY, 50);
                if (deltaX !== 0)
                    this.next?.classList.toggle('qbo-resize', true);
                if (this.type === ResizeType.Vertical) {
                    this.previous.style.height = `${newHeight}px`;
                    this.next.style.height = `calc(100% - ${newHeight}px - ${this.offsetHeight}px)`;
                    // console.log('resized ', this.previous, this.previous?.style.height, this.next, this.next?.style.height);
                }
                else {
                    this.previous.style.width = `${newWidth}px`;
                    this.next.style.width = `calc(100% - ${newWidth}px - ${this.offsetWidth}px)`;
                    // console.log('resized ', this.previous, this.previous?.style.width, this.next, this.next?.style.width);
                }
            }
        };
        const onMouseUp = () => {
            this.isResizing = false;
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        };
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    }
    render() {
        return html `<slot><span></span></slot>`;
    }
};
__decorate([
    state(),
    __metadata("design:type", Object)
], QboResize.prototype, "isResizing", void 0);
__decorate([
    property(),
    __metadata("design:type", String)
], QboResize.prototype, "type", void 0);
QboResize = __decorate([
    customElement('qbo-resize')
], QboResize);
export { QboResize };
